import { useContext, useCallback } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

// Inicia a edição das lâminas — só para pedido com produto Fotolivro, logo após
// a edição aprovada. Quem faz é o editor (perm edit_photos).
const StartSpreadEditingButton = ({ order, has_fotolivro }) => {
  const { hasPermissions } = useContext(AuthContext);

  const hasViewButton = useCallback(
    () => has_fotolivro && hasPermissions(['edit_photos', 'edit_order']),
    [has_fotolivro]
  );

  return (
    <>
      {hasViewButton() && order.order_status === 'Edição aprovada' && (
        <div className="col-sm col-md-6 col-xl-4 mt-2">
          <button
            className="btn btn-success btn-block col-12"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#modal-start-spread-editing-order"
          >
            iniciar edição de lâminas
          </button>
        </div>
      )}
    </>
  );
};

StartSpreadEditingButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  has_fotolivro: PropTypes.bool.isRequired,
};

export default StartSpreadEditingButton;
